export default {
  namespaced: true,
  state: {
    uid: '',
    email: ''
  },
  mutations: {
    onAuthStateChanged(state, payload) {
      state.uid = payload.uid;
      state.email = payload.email;
    }
  },
  actions: {
    initStore({ commit }, payload) {
      commit('onAuthStateChanged', payload);
    },
    signOut({ commit }) {
      commit('onAuthStateChanged', { uid: '', email: '' });
    }
  },
  getters: {
    isSignedIn(state) {
      return state.uid.length != 0;
    }
  }
};
